export const ORDER_OPTION = {
  interest: 'interest',
  limit: 'limit',
};

export const BADGE_BACKGROUND_COLOR = {
  '오늘 입금': 'checkGreen',
  '모바일로 끝': 'checkBlue',
  '대출 불가': 'grey73',
  '전용 상품': 'purple',
  '통신 불가': 'grey73',
};

export const BADGE_COLOR = {
  '오늘 입금': 'green',
  '모바일로 끝': 'blue',
  '대출 불가': 'white',
  '전용 상품': 'purple',
  '통신 불가': 'white',
};

export const DATA_USE_TYPE_KR = {
  CREDIT_LOAN_CMPRS: '신용',
  LOAN_CMPRS: '담보',
};

export const MODAL_DATA_MAP = {
  IRC200: {
    contents: (
      <>
        <p>
          대출 한도 금액이 해당 대출 상품의 신청 가능 한도 금액보다 낮습니다.
        </p>
        <br />
        <ul>
          <li>
            대출 한도 금액은 연동된 판매몰의 정산예정금을 기준으로 계산됩니다.
          </li>
          <li>
            연동 가능한 판매몰이 더 있으신 경우, 데이터를 연동해 주세요.
            연동하는 데이터가 많을수록 대출 한도가 상향될 수 있습니다.
          </li>
        </ul>
      </>
    ),
  },

  IRC300: {
    contents: (
      <>
        <p>본 상품은 대상 판매몰의 셀러 전용 상품 입니다.</p>
        <br />
        <ul>
          <li>대상 판매몰을 확인 후 해당 판매몰을 연동해 주세요.</li>
        </ul>
      </>
    ),
  },

  IRC400: {
    contents: (
      <>
        <p>대출 한도가 확인되지 않습니다.</p>
        <br />
        <ul>
          <li>
            금융기관과 통신이 원활하지 않거나 한도 심사 시간이 아닐 수 있습니다.
            잠시 후 다시 시도해 주세요.
          </li>
        </ul>
      </>
    ),
  },

  IRC500: {
    contents: (
      <>
        <p>
          매출 누적액 기준 상품을 이용할 수 없습니다.
          <br />
          해당 상품 데이터를 사용 중인 건이 존재합니다.
        </p>
      </>
    ),
  },
};
